export const getAdPromoSource = state => state.analytics.get('adPromoSource');
export const getPostalCodeChange = state =>
  state.analytics.get('postalCodeChange');
export const hasEventFired = (state, event) =>
  state.analytics.getIn(['firedEvents', event]);
